/* ISOFIN — Vorher/Nachher-Slider (Before/After) — v214 ausgelagert
   Vorher inline in sections/isofin-startseite.liquid → blockierte Main-Thread.
   Jetzt: defer-loaded extern, läuft nach DOM-Parse. */
(function () {
  'use strict';
  var container = document.querySelector('[data-isf-bna]');
  if (!container) return;
  var afterImg = container.querySelector('.isf-bna__after');
  var line = container.querySelector('.isf-bna__line');
  var handle = container.querySelector('.isf-bna__handle');
  if (!afterImg || !line || !handle) return;

  function setPos(pct) {
    pct = Math.max(0, Math.min(100, pct));
    afterImg.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
    line.style.left = pct + '%';
    handle.style.left = pct + '%';
    handle.setAttribute('aria-valuenow', Math.round(pct));
  }

  function pctFromClientX(clientX) {
    var rect = container.getBoundingClientRect();
    return ((clientX - rect.left) / rect.width) * 100;
  }

  var dragging = false;

  if (window.PointerEvent) {
    container.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { container.setPointerCapture(e.pointerId); } catch (_e) {}
      setPos(pctFromClientX(e.clientX));
      e.preventDefault();
    });
    container.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(pctFromClientX(e.clientX));
    });
    container.addEventListener('pointerup', function (e) {
      dragging = false;
      try { container.releasePointerCapture(e.pointerId); } catch (_e) {}
    });
    container.addEventListener('pointercancel', function () { dragging = false; });
  } else {
    container.addEventListener('mousedown', function (e) {
      dragging = true; setPos(pctFromClientX(e.clientX)); e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (dragging) setPos(pctFromClientX(e.clientX));
    });
    window.addEventListener('mouseup', function () { dragging = false; });
    container.addEventListener('touchstart', function (e) {
      if (!e.touches[0]) return;
      dragging = true; setPos(pctFromClientX(e.touches[0].clientX)); e.preventDefault();
    }, { passive: false });
    window.addEventListener('touchmove', function (e) {
      if (dragging && e.touches[0]) setPos(pctFromClientX(e.touches[0].clientX));
    }, { passive: true });
    window.addEventListener('touchend', function () { dragging = false; });
  }

  handle.addEventListener('keydown', function (e) {
    var cur = parseFloat((line.style.left || '50').replace('%', '')) || 50;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { setPos(cur - 2); e.preventDefault(); }
    if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { setPos(cur + 2); e.preventDefault(); }
    if (e.key === 'Home') { setPos(0); e.preventDefault(); }
    if (e.key === 'End') { setPos(100); e.preventDefault(); }
  });

  setPos(50);
})();
